export type GetHomeMenuDataListResponse = {
  /**
   * The results of this get_home_menu_data_list response body.
   */
  myProjectList: {
    no: string;
    pjtType: string;
    pjtId: string;
    pjtName: string;
    pjtLnchType: string;
    status: string;
    pjtRegisteredDate: string;
    pjtStartedDate: string;
    dipByRgn: string;
    cpntId: string;
    jediPjtDesc: string;
    pjtOwner: string;
    transitionId: string;
    transitionPrm: { [key: string]: string };
    mmTxt: string;
    mmTxtUpdateDateTime: string;
  }[];

  myTodoList: {
    no: string;
    pjtId: string;
    pjtName: string;
    ticketType: string;
    tcktTypeCd: string;
    tcktStsTypeCd: string;
    status: string;
    transitionPrjId: string;
    transitionPrjPrm: { [key: string]: string };
    transitionId: string;
    transitionPrm: { [key: string]: string };
    mmTxt: string;
    mmTxtUpdateDateTime: string;
  }[];
};
